import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SecurePopup from './securePopup';
import { phoneNumber } from '../../helpers/locationHelper';


class HeaderPayment extends PureComponent{

  constructor(){
    super();
    this.state = {
      ISOCurrencyCode:'',
      secureIsOpen:false
    }
    this.onSecureHandler = this.onSecureHandler.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  documentClickHandler(e){
   try{
      if(e.target.offsetParent.className !== "row secure-wrapper"){
        this.setState({secureIsOpen:false});
      }
    }catch(e){}
  }

  componentDidMount(){
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }


  componentDidUpdate(prevProps, prevState) {
    if(this.props.currency !== prevProps.currency){
      this.setState({ISOCurrencyCode:this.props.currency.iso_currency_code});
    }
  }


  onSecureHandler(){
    this.setState({secureIsOpen:!this.state.secureIsOpen});
  }

  render(){

    const { secureIsOpen, ISOCurrencyCode } = this.state;

    return(
      <div className="header-payment"
        id="header-payment">
        <div className="row">
          <div className="column small-12">
            <ul>
              <li>
                <a href={`tel:${phoneNumber(true, ISOCurrencyCode)}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#FFFFFF" d="M487.776 24.051L387.025.806c-14.745-3.405-29.786 4.226-35.749 18.14l-46.5 108.494c-5.452 12.723-1.778 27.73 8.935 36.495l53.854 44.063c-34.011 69.234-90.333 125.557-159.566 159.566l-44.063-53.854c-8.765-10.713-23.774-14.385-36.496-8.935L18.946 351.276C5.031 357.24-2.598 372.275.806 387.026l23.244 100.75C27.342 502.039 39.864 512 54.5 512 306.659 512 512 307.793 512 54.5c0-14.638-9.961-27.159-24.224-30.449zM55.096 480l-22.972-99.557 107.402-46.03 59.53 72.757c103.641-48.624 159.675-104.867 208.113-208.113l-72.758-59.53 46.031-107.402L480 55.096C479.68 289.713 289.638 479.68 55.096 480z"/></svg>
                  {phoneNumber(false, ISOCurrencyCode)}
                </a>
              </li>
              <li onClick={this.onSecureHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#FFFFFF" d="M400 224h-16v-62.5C384 73.1 312.9.3 224.5 0 136-.3 64 71.6 64 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM96 160c0-70.6 57.4-128 128-128s128 57.4 128 128v64H96v-64zm304 320H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16z"/></svg>
                Secure booking
              </li>
            </ul>
          </div>
         </div>


         <div className="row secure-wrapper" style={{display:secureIsOpen ? 'block' : 'none'}}>
          <div className="column small-12">
             <SecurePopup secureLocation="header"/>
           </div>
         </div>

      </div>
    )
  }

}

function mapStateToProps(state){
  return {
    currency:state.currency
  }
}

export default connect(mapStateToProps, null)(HeaderPayment);



// WEBPACK FOOTER //
// ./src/components/shared/payment.js